import { Component, inject } from '@angular/core';
import { AuthService } from '@app/components/login.component';
import { withTooltipState } from '@app/shared/mixins/with-tooltip-state.mixin';
import { isActionOnJedinicaDisabled } from '@app/shared/util/jedinica-gradiva-security-utils';
import { PrimeNGButtonOpenItemViewActionComponent } from '@ntap/primeng';
import { delay, map, withLatestFrom } from 'rxjs';

@Component({
  selector: 'app-edit-jedinica-item-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class EditJedinicaItemActionComponent extends withTooltipState(
  PrimeNGButtonOpenItemViewActionComponent
) {
  private authService = inject(AuthService);

  protected override initDisabledObservable(): void {
    this.isDisabled$ = this.itemProvider.item$.pipe(
      withLatestFrom(this.authService.validUser$),
      map(([item, user]) => {
        return isActionOnJedinicaDisabled(item, user);
      }),
      delay(0),
      map((result) => {
        this.setTooltip(result.message);
        return result.disabled;
      })
    );
  }
}
